import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import allReducers from "./state";
import { createStore, applyMiddleware } from "redux";
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import {Provider} from "react-redux";

const composeEnhancers = composeWithDevTools(
    applyMiddleware(thunk),
    // other store enhancers if any
    );


export const store = createStore(allReducers as any, composeEnhancers);

ReactDOM.render(
// @ts-ignore
    <Provider store={store}>
        <App />
    </Provider>
, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

console.log(`${process.env.REACT_APP_NAME} ${process.env.REACT_APP_VERSION}`)